export const environment = {
  url: 'https://api.miencuesta.app'
}
